import React from 'react';
import { Link } from 'react-router-dom';
import { ChevronRight, Home } from 'lucide-react';

const Breadcrumbs = ({ items }) => (
  <nav aria-label="Breadcrumb" data-testid="breadcrumbs" className="bg-[#F8F9FA] border-b border-black/5 px-6 lg:px-12">
    <ol className="max-w-7xl mx-auto flex items-center gap-1.5 py-3 text-sm text-gray-500 flex-wrap">
      <li>
        <Link to="/" className="inline-flex items-center gap-1 hover:text-emerald-700 transition-colors duration-200">
          <Home size={13} /> Home
        </Link>
      </li>
      {items.map((item, i) => (
        <li key={i} className="inline-flex items-center gap-1.5">
          <ChevronRight size={13} className="text-gray-400" />
          {item.href ? (
            <Link to={item.href} className="hover:text-emerald-700 transition-colors duration-200">{item.label}</Link>
          ) : (
            <span className="text-gray-900 font-medium">{item.label}</span>
          )}
        </li>
      ))}
    </ol>
  </nav>
);

export default Breadcrumbs;
